import { getToken } from './apiRequest';

export const USER_STORAGE_UPDATED_EVENT = 'vantagepoint-user-storage';

export const isAuthenticated = () => {
  return !!getToken();
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

/**
 * Merge fields into the stored session user and notify listeners (same-tab).
 * @param {Record<string, unknown>} partial
 */
export function patchCurrentUser(partial) {
  if (typeof window === 'undefined') return;
  const userStr = localStorage.getItem('user');
  if (!userStr) return;
  try {
    const u = JSON.parse(userStr);
    Object.assign(u, partial);
    localStorage.setItem('user', JSON.stringify(u));
    window.dispatchEvent(new Event(USER_STORAGE_UPDATED_EVENT));
  } catch {
    /* ignore */
  }
}
